import { render, staticRenderFns } from "./TextElement.vue?vue&type=template&id=5577fc5e&scoped=true&"
import script from "./TextElement.vue?vue&type=script&lang=ts&"
export * from "./TextElement.vue?vue&type=script&lang=ts&"
import style0 from "./TextElement.vue?vue&type=style&index=0&id=5577fc5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5577fc5e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VIcon,VSnackbar,VTooltip})
